import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _58a29459 = () => interopDefault(import('../../../pages/contact-opnemen/index.vue' /* webpackChunkName: "pages/contact-opnemen/index" */))
const _ed553b00 = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/index.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/index" */))
const _97eefa5a = () => interopDefault(import('../../../pages/informatie-over-warmtepompen/index.vue' /* webpackChunkName: "pages/informatie-over-warmtepompen/index" */))
const _aa5edf7e = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/bevestigd" */))
const _6be1a4cc = () => interopDefault(import('../../../pages/contact-opnemen/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen/bevestigd" */))
const _44335d54 = () => interopDefault(import('../../../pages/offertes-aanvragen/aanvraag-afgerond.vue' /* webpackChunkName: "pages/offertes-aanvragen/aanvraag-afgerond" */))
const _7d521757 = () => interopDefault(import('../../../pages/offertes-aanvragen/type-isolatie.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-isolatie" */))
const _197b720b = () => interopDefault(import('../../../pages/offertes-aanvragen/type-radiator.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-radiator" */))
const _1202afbb = () => interopDefault(import('../../../pages/offertes-aanvragen/type-verwarming.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-verwarming" */))
const _76b20b19 = () => interopDefault(import('../../../pages/offertes-aanvragen/type-warmtepomp.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-warmtepomp" */))
const _4fcd1cc9 = () => interopDefault(import('../../../pages/offertes-aanvragen/uw-gegevens.vue' /* webpackChunkName: "pages/offertes-aanvragen/uw-gegevens" */))
const _2e15cb18 = () => interopDefault(import('../../../pages/offertes-aanvragen/woning-gebouwd.vue' /* webpackChunkName: "pages/offertes-aanvragen/woning-gebouwd" */))
const _885d57d2 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _17f1aeb2 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.be-nl.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-opnemen",
    component: _58a29459,
    name: "contact-opnemen"
  }, {
    path: "/contact-opnemen-bedrijf",
    component: _ed553b00,
    name: "contact-opnemen-bedrijf"
  }, {
    path: "/informatie-over-warmtepompen",
    component: _97eefa5a,
    name: "informatie-over-warmtepompen"
  }, {
    path: "/contact-opnemen-bedrijf/bevestigd",
    component: _aa5edf7e,
    name: "contact-opnemen-bedrijf-bevestigd"
  }, {
    path: "/contact-opnemen/bevestigd",
    component: _6be1a4cc,
    name: "contact-opnemen-bevestigd"
  }, {
    path: "/offertes-aanvragen/aanvraag-afgerond",
    component: _44335d54,
    name: "offertes-aanvragen-aanvraag-afgerond"
  }, {
    path: "/offertes-aanvragen/type-isolatie",
    component: _7d521757,
    name: "offertes-aanvragen-type-isolatie"
  }, {
    path: "/offertes-aanvragen/type-radiator",
    component: _197b720b,
    name: "offertes-aanvragen-type-radiator"
  }, {
    path: "/offertes-aanvragen/type-verwarming",
    component: _1202afbb,
    name: "offertes-aanvragen-type-verwarming"
  }, {
    path: "/offertes-aanvragen/type-warmtepomp",
    component: _76b20b19,
    name: "offertes-aanvragen-type-warmtepomp"
  }, {
    path: "/offertes-aanvragen/uw-gegevens",
    component: _4fcd1cc9,
    name: "offertes-aanvragen-uw-gegevens"
  }, {
    path: "/offertes-aanvragen/woning-gebouwd",
    component: _2e15cb18,
    name: "offertes-aanvragen-woning-gebouwd"
  }, {
    path: "/",
    component: _885d57d2,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/privacy",
    component: _861e7d2c,
    name: "privacy"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/algemene-voorwaarden",
    component: _17f1aeb2,
    name: "algemene-voorwaarden"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
